import React, { ChangeEvent, FocusEvent, useState } from "react";
import { TextField, InputAdornment, Typography, IconButton } from "@mui/material";
import { Language } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { updateQrText } from "../../state/mainSlice";
import { Root } from "../../state/types";
import { ContentPaste } from "@mui/icons-material";

interface Props {
  record(): void;
}

const URLinput = ({ record }: Props) => {
    const dispatch = useDispatch();
    const globalValue = useSelector((state: Root) => state.qrData.qrText);
    const [localValue, setLocalValue] = useState(globalValue || "");

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
      setLocalValue(e.target.value);
    };

    const onBlur = (event: FocusEvent<HTMLInputElement>) => {
        let url = event.target.value.trim();

        if (url && !url.startsWith("http://") && !url.startsWith("https://")) {
            url = `https://${url}`;
        }

        record();
        dispatch(updateQrText(url)); 
    };

    const handlePaste = async () => {
      try {
          const text = await navigator.clipboard.readText();
          if (text) {
              setLocalValue(text);
              dispatch(updateQrText(text));
          }
      } catch (error) {
          console.error("Failed to read clipboard content:", error);
      }
  };

    return (
        <TextField
          variant="outlined"
          fullWidth
          value={localValue}
          onChange={onChange}
          onBlur={onBlur}
          placeholder="Enter a link"
          InputProps={{
              startAdornment: (
                  <InputAdornment position="start">
                      {localValue.startsWith("http://") || localValue.startsWith("https://") ? null : (
                          <Typography color="gray">https://</Typography>
                      )}
                  </InputAdornment>
              ),
              endAdornment: (
                  <InputAdornment position="end">
                      <IconButton onClick={handlePaste} edge="end">
                          <ContentPaste />
                      </IconButton>
                  </InputAdornment>
              ),
          }}
        />
    );
};

export default URLinput;
